export default {
  confirmLabel: 'Done',
  backspaceLabel: 'Backspace',
  cancelKeyboardLabel: 'CancelKeyboard',
};
